
/**
 * @namespace
 */

let image = {};


/**
 *获取图片信息
 *
 * @param team_id
 * @param image_id
 * @returns
 */

image.getImageInfo = async function(team_id,image_id){

    let url = '/project/image',
        data = {
            team_id,
            image_id
        };

    try{
        let res = await axios.get(url,{
            params:data
        });
        return res;
    }catch(err){
        console.log(err);
    }
    
    return null;
}


/**
 *获取图片评论
 *
 * @param {Object} params
 * @param params.image_id 图片id 该图片下的所有批注
 * @param params.all 表示是否全部批注
 * @param params.vid 版本id 该版本下的所有批注
 * @param params.read 表示是否已读批注
 * @returns {Object}
 */

image.getComments = async function(params){

    let url = '/project/comment',
        data = params;

    try{
        let res = await axios.get(url,{
            params:data
        });
        return res;
    }catch(err){
        console.log(err);
    }
    
    return null;
}


/**
 *添加打点评论
 *
 * @param {Object} params
 * @param params.project_id 项目id
 * @param params.version_id 版本id
 * @param params.content 评论内容
 * @param params.p_name 所属项目名称（string 类型）
 * @param params.image_id 对应图片id
 * @param params.position_x 打点评论位置信息
 * @param params.position_y 打点评论位置信息
 * @param params.text 点文本
 * @param params.reply_id 如果是回复的话，回复评论的id
 * @param params.team_id 团队id, 微信端需要
 * @param params.width 框选区域宽
 * @param params.height 框选区域高
 * @returns
 */

image.addComment = async function(params){

    let url = '/project/comment',
        data = params;

    try{
        let res = await axios.post(url,data);
        return res;
    }catch(err){
        console.log(err);
    }
    
    return null;
}


export default image;



/**
 *获取原型首页
 *
 * @param team_id
 * @param pid
 * @returns 
 */

image.getProtoHome = async function(team_id,pid){

    let url = '/project/image_home',
        data = {
            team_id,
            pid
        };

    try{
        let res = await axios.get(url,{
            params:data
        });
        return res;
    }catch(err){
        console.log(err);
    }
    
    return null;
}


/**
 *获取图片评论
 *
 * @param image_id
 * @param vid  //版本id
 * @param page
 * @param pageSize
 * @returns
 */
image.getImageComments = async function(image_id,vid,page,pageSize){

    let url = '/project/comment',
        data = {
            image_id,
            page,
            pageSize,
            vid
        };

    try{
        let res = await axios.get(url,{
            params:data
        });
        return res;
    }catch(err){
        console.log(err);
    }
    
    return null;
}


/**
 * 添加评论
 *
 * @param {object} params
 * @param params.project_id
 * @param params.version_id
 * @param params.content
 * @param params.p_name
 * @param params.image_id
 * @param params.position_x
 * @param params.position_y
 * @param params.text
 * @param params.width
 * @param params.height
 * @param params.reply_id   //可选 如果是回复的话，回复评论的id
 * @returns
 */
image.addImageComment = async function(params){

    let url = '/project/comment',
        data = params;

    try{
        let res = await axios.post(url,data);
        return res;
    }catch(err){
        console.log(err);
    }
    
    return null;
}